export default __webpack_public_path__ + "static/media/recuca.d2acde83.jpeg";